import { MatchmakingFormConfig } from 'matchmaking/models';
import { Injectable, inject } from '@angular/core';
import { ICustomWindow, WindowRefService } from '@sirius/common';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private _windowRef = inject(WindowRefService);

    private readonly STORAGE_KEY = 'matchmaking_form_data';
    private readonly EXPIRY_KEY = 'matchmaking_form_expiry';
    private readonly EXPIRY_HOURS = 1;

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }


    constructor() {
    }

    getData(): MatchmakingFormConfig | null {
        if (!this.Window) {
            return null;
        }

        const savedData = localStorage.getItem(this.STORAGE_KEY);
        const expiryTime = localStorage.getItem(this.EXPIRY_KEY);

        if (!savedData || !expiryTime) {
            return null;
        }

        if (this.isExpired(parseInt(expiryTime))) {
            this.clearStorage();
            return null;
        }

        try {
            return JSON.parse(savedData);
        } catch {
            this.clearStorage();
            return null;
        }
    }

    saveData(data: MatchmakingFormConfig) {
        const expiryTime = new Date().getTime() + (this.EXPIRY_HOURS * 60 * 60 * 1000);

        try {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
            localStorage.setItem(this.EXPIRY_KEY, expiryTime.toString());
        } catch (error) {
            console.error('Failed to save to localStorage:', error);
        }
    }

    private isExpired(expiryTime: number): boolean {
        return new Date().getTime() > expiryTime;
    }

    private clearStorage() {
        localStorage.removeItem(this.STORAGE_KEY);
        localStorage.removeItem(this.EXPIRY_KEY);
    }
}
